import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import MenuLinks from './MenuLinks';
import { DashboardMenuProps } from '@/types/props/components';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { HeaderEnum } from '@/types/translations/HeaderEnum';

const Menu = ({
  queryClient,
  userQuery,
  ctaCountQuery,
  tHeader,
}: DashboardMenuProps) => {
  const { translate } = useTypedTranslation<HeaderEnum>('header');
  return (
    <Row>
      <Col>
        <h5 className="font-size-12 fw-500 py-3 text-secondary ps-4">
          {translate(HeaderEnum['main_menu.main_menu'])}
        </h5>
        <div className="me-2">
          <MenuLinks
            userQuery={userQuery}
            ctaCountQuery={ctaCountQuery}
            queryClient={queryClient}
            tHeader={tHeader}
          />
        </div>
      </Col>
    </Row>
  );
};

export default Menu;
